import { ChangeDetectionStrategy, Component } from '@angular/core';

import { AuthService } from '@auth0/auth0-angular';

import { ReleaseNoteService } from '@ups/xplat/core';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'ups-release-checker',
  template: `
    <ups-announcements-popup></ups-announcements-popup>
    <ups-release-note-popup></ups-release-note-popup>
  `,
  standalone: false,
})
export class ReleaseNoteComponent {
  constructor(auth: AuthService, release: ReleaseNoteService) {
    auth.isAuthenticated$.subscribe((isAuthenticated) => {
      if (isAuthenticated) {
        release.onLogin();
      }
    });
  }
}
